import React from 'react'
import gql from 'graphql-tag'
import Subscription from './Subscription'
import DataContainer from 'components/DataContainer/DataContainer'
import Loadable from 'components/Loadable/Loadable'
import Loader from 'components/UI/Loader/Loader'
import { queries, mutations } from './graphql'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import { LoaderWrapper } from '../../DashboardSettings.styles'

class SubscriptionContainer extends React.Component {
  handleStripeToken (plan, token, coupon) {
    return new Promise((resolve, reject) => {
      this.props
        .subscribeToPlan(token.id, plan.id, coupon)
        .then(async r => {
          await this.setState({
            currentSubscription: r.data.subscribeToPlan
          })
          return resolve(true)
        })
        .catch(e => {
          console.error(e)
          return reject(e)
        })
    })
  }

  async getDiscount (client, couponId) {
    const { data } = await client.query({
      query: gql`
        query findDiscountCode($couponId: String) {
          findDiscountCode(couponId: $couponId)
        }
      `,
      variables: { couponId },
      fetchPolicy: 'network-only'
    })
    return data.findDiscountCode
  }

  render () {
    return (
      <Loadable
        {...this.props}
        loadingComponent={
          <LoaderWrapper><Loader bgColor='#FFF' itemColor={colors.pink} itemSize={100} /></LoaderWrapper>
        }
      >
        <Subscription
          {...this.props}
          getDiscount={this.getDiscount.bind(this, this.props.client)}
          handleStripeToken={this.handleStripeToken.bind(this)}
          onRequestInvoice={this.props.requestQuote}
        />
      </Loadable>
    )
  }
}

export default props => (
  <DataContainer queries={queries} mutations={mutations}>
    <SubscriptionContainer {...props} />
  </DataContainer>
)
